import { Link } from 'react-router-dom'
import { useAdminAuthors } from './authorsStore'

export default function AdminContributors() {
  const { authors: people, loaded } = useAdminAuthors()

  if (!loaded) return <p className="text-muted">Loading contributors…</p>

  return (
    <section>
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-caps text-[10px] text-rose">People</p>
          <h2 className="mt-1 font-serif text-[32px] leading-none font-medium">Contributors</h2>
        </div>
        <Link to="/admin/contributors/new" className="text-caps inline-flex h-9 items-center bg-ink px-4 text-white hover:bg-rose">
          Add New
        </Link>
      </div>
      {people.length === 0 ? (
        <p className="mt-6 max-w-[46ch] text-copy">No contributors yet.</p>
      ) : (
        <ul className="mt-5 divide-y divide-rule border-y border-rule">
          {people.map((person) => (
            <li key={person.id}>
              <Link to={`/admin/contributors/${person.id}`} className="block py-2 text-[15px] leading-snug hover:text-rose">
                {person.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
